import { PublicClientApplication, EventType } from '@azure/msal-browser';

function initMsal(config, langcode) {
  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: config.auth.clientId,
      authority: config.auth.authority + 'b2c_1a_generalsignupsignin',
      redirectUri: config.auth.redirectUri[langcode],
      postLogoutRedirectUri: config.auth.redirectUri[langcode],
      knownAuthorities: [
        'https://careerswalesonlinestaging.b2clogin.com',
        'https://careerswalesonlineuat.b2clogin.com',
        'https://login.careerswales.gov.wales'
      ]
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    }
  });

  // Handle forgotten password redirect.
  msalInstance.addEventCallback((message) => {
    if (message.eventType === EventType.LOGIN_FAILURE) {
      if (message.error.errorMessage.includes('AADB2C90118')) {
        msalInstance.loginRedirect({
          authority: config.auth.authority + 'b2c_1a_forgottenpassword',
          extraQueryParameters: {
            lang: langcode
          }
        });
      }
    }
  });

  return msalInstance;
}

export default initMsal;
